import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import verification from "../../../api/verification";
import limitsApi from "../../../api/limits";
import accountsApi from "../../../api/accounts";
import CustomerInfoCom from "../CustomerInfoCom";
import LoadingOverlay from "../../Components/LoadingOverlay";
import { getStoredItem, setStoredItem } from "../../../store/dataStore";

import {
  approveVerificationRequest,
  rejectVerificationRequest,
} from "../../../util/verificationRequestHelper";
import { handleError } from "@/util/errorHandler";

class CustomerInfo extends Component {
  state = {
    data: {},
    isLoading: true,
  };

  limitsList = getStoredItem("active-limits-list");

  loadUserInfo = async id => {
    try {
      const verificationRequestData = await verification.getVerificationRequest(
        id,
      );
      const accountDetailsData = await accountsApi.getAccountDetails(
        verificationRequestData.accountId,
      );

      this.setState({
        data: {
          ...verificationRequestData,
          ...accountDetailsData,
        },
      });
    } catch (err) {
      handleError(err);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  loadOrTakeFromCacheLimitsList = () => {
    if (!this.limitsList) {
      limitsApi
        .getLimitsListAll()
        .then(limits => {
          setStoredItem("active-limits-list", JSON.stringify(limits));
          this.limitsList = JSON.stringify(limits);
        })
        .catch(error => handleError(new Error(error.response)));
    }
  };

  componentDidMount() {
    const id = this.props.match.params.id;
    this.loadUserInfo(id);
    this.loadOrTakeFromCacheLimitsList();
  }

  render() {
    const id = this.props.match.params.id;
    const { accountId } = this.state.data;

    return (
      <div>
        <Row>
          <Col style={{ display: "relative" }}>
            <LoadingOverlay loading={this.state.isLoading} />
            <CustomerInfoCom
              data={this.state.data}
              onApprove={selectedUserLimit =>
                approveVerificationRequest(
                  {
                    verificationId: id,
                    limitId: selectedUserLimit,
                  },
                  () => this.props.history.push(`/kyc_info/${accountId}`),
                )
              }
              onReject={() =>
                rejectVerificationRequest(id, () =>
                  this.props.history.push(`/kyc_info/${accountId}`),
                )
              }
              approvable
              updateAccount={verificationRequestId => {
                if (verificationRequestId) {
                  this.props.history.replace(
                    `/customer_kyc_info/${verificationRequestId}`,
                  );
                } else {
                  this.loadUserInfo(id);
                }
              }}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default CustomerInfo;
